import React, { useRef, useEffect, useState } from "react";
import "./Checkbox.scss";

// Icons used
import { Minus, TickRight } from "../../../ui/icons";

// Custom Typography component
import { L } from "../../../ui/Typography";

const Checkbox = ({
  id, // ID for the input
  name, // Name for the input (used in forms)
  label, // Optional label text
  checked, // Controlled checked state (optional)
  className = "", // Extra custom classes
  defaultChecked = false, // Default checked state (for uncontrolled)
  indeterminate = false, // Indeterminate state (used in partial selection)
  disabled = false, // Disable interaction
  onChange = () => {}, // Callback triggered on toggle
  size = "md", // Size variant
}) => {
  /* === useState === */
  const [internalChecked, setInternalChecked] = useState(defaultChecked); // Internal toggle state
  /* === End useState === */

  /* === useRef === */
  const inputRef = useRef(null); // Ref for accessing native checkbox DOM
  /* === End useRef === */

  /* === Sync internalChecked with external controlled 'checked' prop === */
  useEffect(() => {
    if (checked !== undefined) {
      setInternalChecked(checked); // Override internal state
    }
  }, [checked]);
  /* === End Sync === */

  /* === Sync indeterminate state to native checkbox === */
  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.indeterminate = indeterminate;
    }
  }, [indeterminate]);
  /* === End Indeterminate Sync === */

  const effectiveChecked = internalChecked; // Determine which value to use: internal state (used for both controlled & uncontrolled)

  /* === Handle toggle when user clicks === */
  const handleToggle = () => {
    if (disabled) return; // Prevent toggle if disabled
    const newValue = !internalChecked;
    setInternalChecked(newValue); // Update internal state
    onChange(newValue); // Trigger callback to parent
  };
  /* === End Toggle Handler === */

  return (
    <div
      className={`custom-checkbox-wrapper ${className} ${size} ${
        disabled ? "disabled" : ""
      } ${effectiveChecked ? "checked" : indeterminate ? "indeterminate" : ""}`}
    >
      <input
        ref={inputRef}
        type="checkbox"
        id={id}
        name={name}
        checked={effectiveChecked}
        disabled={disabled}
        onChange={() => {}} // Prevent default behavior (we manage state manually)
        style={{ display: "none" }}
      />
      {size == "sm" ? (
        <div
          className="custom-checkbox-parent borderWrapperJustOneCorner"
          onClick={handleToggle}
        >
          <div className="custom-checkbox">
            {effectiveChecked ? (
              <TickRight size="sm" />
            ) : indeterminate ? (
              <Minus size="sm" />
            ) : (
              ""
            )}
          </div>
        </div>
      ) : (
        <div
          className="borderWrapper custom-checkbox-parent"
          onClick={handleToggle}
        >
          <div className="borderInner">
            <div className="custom-checkbox">
              {effectiveChecked ? (
                <TickRight size="sm" />
              ) : indeterminate ? (
                <Minus size="sm" />
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      )}
      {label && (
        <L htmlFor={id} className="checkbox-label" onClick={handleToggle}>
          {label}
        </L>
      )}
    </div>
  );
};

export default Checkbox;
